var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"text-2xl leading-8 font-bold tracking-tight sm:text-3xl sm:leading-9 md:pt-8 lg:pt-12 xl:pt-16"},[_vm._t("default",[_vm._v("Title")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }